import { Component, computed, inject, Input } from '@angular/core';
import { CartItemStateService } from '../../../services/cart-item-state.service';
import { CiAccessory, CiInputValue } from '../../../model/cart-item';
import { AvailableSlotDto } from '../../../model/product';
import { LibModulesWolcModule } from '../../lib-modules-wolc.module';
import { BtOrderInputFieldsComponent } from '../order-input-fields/order-input-fields.component';

@Component({
  selector: 'btlib-order-accessory-item',
  standalone: true,
  imports: [LibModulesWolcModule, BtOrderInputFieldsComponent],
  templateUrl: './order-accessory-item.component.html',
  styleUrl: './order-accessory-item.component.scss'
})
export class BtOrderAccessoryItemComponent {
  state = inject(CartItemStateService);

  @Input({ required: true }) accessory!: CiAccessory;

  selectedTimeValue = computed(() => {
    const t = this.accessory.selectedTime;
    if (!t || !t.startTime || !t.endTime) return null;
    return `${t.startTime}-${t.endTime}`;
  });

  // Total for this accessory line: unit amount * quantity.
  // Reads from state signal to stay reactive when quantity changes
  // (accessory @Input is not a signal).
  accessoryLineAmount = computed(() => {
    const acc = this.state.accessories().find(a => a.id === this.accessory.id);
    const a = acc ?? this.accessory;
    const qty = a.quantity > 0 ? a.quantity : 1;
    return (a.amount ?? 0) * qty;
  });

  toggle(selected: boolean): void {
    this.state.toggleAccessory(this.accessory.id, selected);
  }

  updateQuantity(quantity: number): void {
    this.state.updateAccessoryQuantity(this.accessory.id, quantity);
  }

  loadTimeSlots(): void {
    if (this.accessory.timeSlots.length === 0) {
      this.state.loadAccessoryTimeSlots(this.accessory.id);
    }
  }

  onTimeChange(value: string): void {
    const slot = this.accessory.timeSlots.find(s => `${s.startTime}-${s.endTime}` === value) || null;
    this.state.selectAccessoryTime(this.accessory.id, slot);
  }

  onInputValueChange(inputValue: CiInputValue): void {
    this.state.updateAccessoryInputValue(this.accessory.id, inputValue);
  }
}
